import { hasLineBreakMarkers, normalizeTextLineBreaksByDevice } from './normalizeTextLineBreaksByDevice';

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  Object.prototype.toString.call(value) === '[object Object]';

/** Рекурсивно нормализует только строки с маркерами [BREAK_MOBILE] / [BREAK_DESKTOP]. */
export const deepNormalizeLineBreaksByDevice = <T>(value: T, isMobile: boolean): T => {
  if (typeof value === 'string') {
    return (hasLineBreakMarkers(value) ? normalizeTextLineBreaksByDevice(value, isMobile) : value) as unknown as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => deepNormalizeLineBreaksByDevice(item, isMobile)) as unknown as T;
  }

  if (!isPlainObject(value)) {
    return value;
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, nested]) => [key, deepNormalizeLineBreaksByDevice(nested, isMobile)]),
  ) as unknown as T;
};
